import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=14baaa44&scoped=true"
import script from "./materials.vue?vue&type=script&lang=js"
export * from "./materials.vue?vue&type=script&lang=js"
import style0 from "./materials.vue?vue&type=style&index=0&id=14baaa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14baaa44",
  null
  
)

export default component.exports